import { render, staticRenderFns } from "./ModalInativarEmpresa.vue?vue&type=template&id=2705827e"
import script from "./ModalInativarEmpresa.vue?vue&type=script&lang=js"
export * from "./ModalInativarEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports